import React, { FC, useRef, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, IonFooter, useIonViewWillLeave, IonInfiniteScroll, IonInfiniteScrollContent, IonDatetime, useIonViewWillEnter } from '@ionic/react'
import { storeMobx, memberMobx, invoiceMobx } from '@mobxStore'
import { useHistoryNew, showMsg, getPlatform } from '@utils'
import env from 'env'
import { format, ddayjs } from '@dt/fe-utils'
import { map } from '@dt/fe-utils/dist/lodash'
import { UseHeader, Tabs, MktEmpty } from '@cps'
import InvoiceApi from '@api/invoice.api'
import './index.scss'
import { permissionMobx } from '@mobx/app'

const { isWeixinMiniProgram } = getPlatform()

interface IProps extends IPage, RouteComponentProps { }

const pageSize: number = 12

const InvoicePage: FC<IProps> = () => {
  const history = useHistoryNew()
  // {
  //   label: i18n.t('invoice.invoicing'),
  //   value: 'order'
  // },
  const typeArr: any[] = [{
    label: i18n.t('invoice.historyInvoicing'),
    value: 'history'
  }, {
    label: i18n.t('invoice.record'),
    value: 'record'
  }]
  const [type, setType] = useState<string>('history')
  const [page, setPage] = useState<number>(1)
  const [invoices, setInvoices] = useState<any[]>([])
  const [canget, setCanget] = useState<boolean>(true)
  const [orderTime, setOrderTime] = useState<string>(ddayjs().subtract(2, 'M').format('YYYY-MM-DD HH:mm:ss'))
  const contentRef = useRef(null)
  // Data Method
  const checkDisable = (item: IOrder, click = false) => {
    if (!invoiceMobx.selectStoreIds.includes(item.storeId) && invoiceMobx.selectStoreIds.length) {
      return i18n.t('invoice.justmergeopen')
    } else if (item.openInvoiceStatus === 'init' || item.openInvoiceStatus === 'siging') {
      if (click) {
        const { url } = invoiceMobx.getInvoiceUrl(env.openInvoiceUrl, item.ordersId)
        window.location.href = url
      }
      return i18n.t('invoice.opeing')
    } else if (item.openInvoiceStatus === 'success') {
      return i18n.t('invoice.hasopen')
    } else if (item.invoiceAmount <= 0) {
      return i18n.t('invoice.zero')
    } else {
      return ''
    }
  }
  const getInvoices = (pageNum: number, data: any[]) => {
    const para: any = {
      brandId: `${storeMobx.brand.brandId}`,
      memberId: `${memberMobx.memberInfo.memberId}`,
      page: pageNum,
      limit: pageSize,
    }
    InvoiceApi.member(para).then((res: any) => {
      if (!res.error) {
        setInvoices(data.concat(res.result.items))
        if (pageNum >= Math.ceil(res.result.meta.totalItems / pageSize)) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    })
  }
  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        setPage(page + 1)
        ev.target.complete()
      }, 500)
    }
  }
  // Component Event
  const viewInvoice = (url: string) => {
    if (isWeixinMiniProgram) {
      history.push('/myInvoice/not', { url })
    } else {
      window.location.href = url
    }
  }
  /** 去开票 */
  const goDrawBill = () => {
    if (!invoiceMobx.selectedOrders.length) {
      showMsg(i18n.t('invoice.selectOrder'))
      return false
    } else {
      // if (!invoiceMobx.checkSelectInvoiceIsVaild) {
      //   showMsg(i18n.t('invoice.noopen'))
      //   return false
      // } else {
      const { url } = invoiceMobx.getInvoiceUrl(env.openInvoiceUrl, '')
      window.location.href = url
      // }
    }
  }
  /** 选择月份 */
  const openMonthPicker = () => {
    return (
      <IonDatetime
        data-cypid='mmgInvoiceDatePicker'
        displayFormat='YYYY-MM'
        cancelText={i18n.t('common.cancel')}
        doneText={i18n.t('common.confirm')}
        value={orderTime}
        onIonChange={(e) => setOrderTime(format.toMonthDateYear(e.detail.value))}
        max={ddayjs().format('YYYY-MM-DD')}
        min={ddayjs(orderTime).subtract(12, 'M').format('YYYY-MM-DD')}
        style={{ height: '100%' }}
      >
      </IonDatetime>
    )
  }
  // Component Effect
  useIonViewWillLeave(() => {
    invoiceMobx.resetInvoiceList()
  })
  useIonViewWillEnter(() => {
    if (!permissionMobx.checkAuthToKey('electronic_invoice')) {
      invoiceMobx.init()
    }
  })
  useEffect(() => {
    if (type === 'record') {
      getInvoices(page, page === 1 ? [] : invoices)
    } else if (type === 'history') {
      if (orderTime) {
        const endTime = ddayjs(orderTime).add(12, 'month').valueOf() > ddayjs().valueOf() ? ddayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss') : ddayjs(orderTime).add(12, 'month').endOf('day').format('YYYY-MM-DD HH:mm:ss')
        invoiceMobx.search({ startTime: ddayjs(orderTime).startOf('day').format('YYYY-MM-DD HH:mm:ss'), endTime: endTime })
      }
    } else {
      invoiceMobx.search({ startTime: ddayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'), endTime: ddayjs().format('YYYY-MM-DD HH:mm:ss') })
    }
  }, [type, page, orderTime])
  return (
    <IonPage className='invoice-page'>
      <UseHeader className='invoice-header' onBack={() => history.goBack()} title={i18n.t('invoice.myInvoice')}>
        <div className='invoice-nav-bar '>
          <Tabs
            data={typeArr} value={type} onChange={(val: any) => {
              if (type === val) return
              setType(val)
              setPage(1)
              contentRef.current && contentRef.current.scrollToTop()
            }}
          >
          </Tabs>
        </div>
      </UseHeader>
      {
        type === 'order' &&
          <>
            <IonContent>
              <div className='invoice-ordes-main'>
                {
                  invoiceMobx.curInvoiceOrderList.length
                    ? (
                      <>
                        <div className='invoice-ordes-list'>
                          {map(invoiceMobx.curInvoiceOrderList, (item: IOrder) => {
                            return item.openInvoiceStatus !== 'success' && (
                              <div key={item.ordersId} className={`invoice-ordes-item ${checkDisable(item).length ? 'disable' : ''}`}>
                                <i data-cypid='mmgCheckInvoice' onClick={() => !checkDisable(item, true).length && invoiceMobx.toggleChcek(item)} className={`iconfont ${invoiceMobx.selectedIds.includes(item.ordersId) ? 'icon-checkbox--checked--filled' : 'icon-checkbox'}`}></i>
                                <div className='main'>
                                  <div className='title'>{item.subject}</div>
                                  <div className='text'>{i18n.t('invoice.orderNo')}: {item.ordersId}</div>
                                  <div className='text'>{i18n.t('invoice.addTime')}: {format.toDateTime(item.acceptTime || item.addTime)}</div>
                                  {
                                    checkDisable(item).length > 0 && <span className='status'>{checkDisable(item)}</span>
                                  }
                                </div>
                                <div className='price'>{format.toPrice(item.invoiceAmount || item.paidFee)}</div>
                              </div>
                            )
                          })}
                        </div>
                      </>
                    )
                    : (
                      <div className='invoice-no-item'>
                        <i className='iconfont icon-magnify'></i>
                        <span>{invoiceMobx.isLoading ? i18n.t('invoice.searching') : i18n.t('invoice.noopeninvoice')}</span>
                      </div>
                    )
                }
              </div>
            </IonContent>
            <IonFooter>
              <div className='order-footer'>
                <div className='footer-choosed'>
                  <span className='title'>{i18n.t('invoice.choosed', { num: invoiceMobx.selectedOrders.length })} {i18n.t('invoice.count')} {format.toPrice(invoiceMobx.totalInvoicePrice)}</span>
                  <span className='desc'>{i18n.t('invoice.invoicingTip')}</span>
                </div>
                <div className='footer-next'>
                  <div data-cypid='mmgCheckAllInvoice' className='left' onClick={() => invoiceMobx.toggleChcek(invoiceMobx.curInvoiceOrderList[0], true)}>
                    <i className={`iconfont ${invoiceMobx.isSelectAll === 'action' ? 'icon-checkbox--checked--filled' : 'icon-checkbox'}`}></i>
                    <span>{i18n.t('common.selectAll')}</span>
                  </div>
                  <div data-cypid='mmgDrawBill' className='btn' onClick={goDrawBill}>{i18n.t('mkt.common.next')}</div>
                </div>
              </div>
            </IonFooter>
          </>
      }
      {
        type === 'history' &&
          <>
            <IonContent class='history-content'>
              {
                !orderTime &&
                  <div className='choose-order-time-block'>
                    <div className='choose-order-time-tip'>{i18n.t('invoice.timeLimit')}</div>
                    <div className='choose-order-time'>
                      {i18n.t('invoice.chooseOrderTime')}
                      <div className='time-picker'>{openMonthPicker()}</div>
                    </div>
                  </div>
              }
              {
                orderTime &&
                  <div className='cur-order-time'>
                    <div className='time-picker'>{openMonthPicker()}</div>
                    <span className='pre-order-time'>{ddayjs(orderTime).format('YYYY-MM-DD')} {i18n.t('mkt.common.to')} {ddayjs(orderTime).add(12, 'month').valueOf() > ddayjs().valueOf() ? ddayjs().format('YYYY-MM-DD') : ddayjs(orderTime).add(12, 'month').format('YYYY-MM-DD')}</span>
                    <i className='iconfont icon-chevron-down'></i>
                  </div>
              }
              {
                orderTime &&
                  <div className='invoice-ordes-main'>
                    {
                      invoiceMobx.curInvoiceOrderList.length
                        ? (
                          <>
                            <div className='invoice-ordes-list'>
                              {map(invoiceMobx.curInvoiceOrderList, (item: IOrder) => {
                                return item.openInvoiceStatus !== 'success' && (
                                  <div key={item.ordersId} className={`invoice-ordes-item ${checkDisable(item).length ? 'disable' : ''}`}>
                                    <i data-cypid='mmgCheckInvoice' onClick={() => !checkDisable(item, true).length && invoiceMobx.toggleChcek(item)} className={`iconfont ${invoiceMobx.selectedIds.includes(item.ordersId) ? 'icon-checkbox--checked--filled' : 'icon-checkbox'}`}></i>
                                    <div className='main'>
                                      <div className='title'>{item.subject}</div>
                                      <div className='text'>{i18n.t('invoice.orderNo')}: {item.ordersId}</div>
                                      <div className='text'>{i18n.t('invoice.addTime')}: {format.toDateTime(item.acceptTime || item.addTime)}</div>
                                      {
                                        checkDisable(item).length > 0 && <span className='status'>{checkDisable(item)}</span>
                                      }
                                    </div>
                                    <div className='price'>{format.toPrice(item.invoiceAmount || item.paidFee)}</div>
                                  </div>
                                )
                              })}
                            </div>
                          </>
                        )
                        : (
                          <div className='invoice-no-item'>
                            <i className='iconfont icon-magnify'></i>
                            <span>{invoiceMobx.isLoading ? i18n.t('invoice.searching') : i18n.t('invoice.noopeninvoice')}</span>
                          </div>
                        )
                    }
                  </div>
              }
            </IonContent>
            {
              orderTime &&
                <>
                  {/* <div className={`last-month${invoiceMobx.curInvoiceOrderList.length ? '' : ' last-month-bg'}`} onClick={() => setOrderTime(ddayjs(orderTime).subtract(1, 'month').format('YYYY-MM'))}>
                    <i className='iconfont icon-chevron-left'></i>
                    <span>{i18n.t('invoice.lastMonth')}</span>
                  </div> */}
                  <IonFooter>
                    <div className='order-footer'>
                      <div className='footer-choosed'>
                        <span className='title'>{i18n.t('invoice.choosed', { num: invoiceMobx.selectedOrders.length })} {i18n.t('invoice.count')} {format.toPrice(invoiceMobx.totalInvoicePrice)}</span>
                        <span className='desc'>{i18n.t('invoice.invoicingTip')}</span>
                      </div>
                      <div className='footer-next'>
                        <div data-cypid='mmgCheckAllInvoice' className='left' onClick={() => invoiceMobx.toggleChcek(invoiceMobx.curInvoiceOrderList[0], true)}>
                          <i className={`iconfont ${invoiceMobx.isSelectAll === 'action' ? 'icon-checkbox--checked--filled' : 'icon-checkbox'}`}></i>
                          <span>{i18n.t('common.selectAll')}</span>
                        </div>
                        <div data-cypid='mmgToDrawBill' className='btn' onClick={goDrawBill}>{i18n.t('mkt.common.next')}</div>
                      </div>
                    </div>
                  </IonFooter>
                </>
            }
          </>
      }
      {
        type === 'record' &&
          <>
            <IonContent className='page-content' ref={contentRef}>
              {invoices.length === 0 && <MktEmpty text={i18n.t('invoice.norecord')} />}
              {invoices.length > 0 &&
                <div className='flow-table'>
                  {
                    invoices.map((item: any, index: number) => {
                      return (
                        <div key={index} className='flow-item'>
                          <div className='item-area'>
                            <div>
                              <span>{item.buyerName}</span>
                              <span className='label'>{item.buyerTaxnum ? i18n.t('invoice.enterprise') : i18n.t('invoice.person')}</span>
                            </div>
                            {
                              item.buyerTaxnum && <div>{i18n.t('invoice.buyerTaxnum')}: {item.buyerTaxnum}</div>
                            }
                            <div className='item-time'>
                              <span className='email'>{item.email || item.mobile}</span>
                              <span>{format.toDateTime(item.addTime)}</span>
                            </div>
                            <div className='item-con'>
                              <span data-cypid='mmgClickInvoice' onClick={() => viewInvoice(item.invoiceUrl)}>{i18n.t('invoice.viewInvoice')}</span>
                            </div>
                          </div>
                          <div>{format.toPrice(item.taxfreeamt + item.tax)}</div>
                        </div>)
                    })
                  }
                  {
                    !canget && <div className='no-more'>{i18n.t('invoice.noMore')}</div>
                  }
                </div>}
              {
                canget &&
                  <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
                    <IonInfiniteScrollContent
                      loadingSpinner='bubbles'
                      loadingText={i18n.t('order.loadmore')}
                    >
                    </IonInfiniteScrollContent>
                  </IonInfiniteScroll>
              }
            </IonContent>
          </>
      }
    </IonPage>
  )
}
export default observer(InvoicePage)
